import { Select, SelectProps } from '@mantine/core';
import { IconCaretDownFilled } from '@tabler/icons-react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface PfSelectProps extends SelectProps {}

export function PfSelect(props: PfSelectProps) {
  const rightSection = () => {
    const chevron = <IconCaretDownFilled size={props.size} />;
    if (!props.clearable) {
      return chevron;
    }

    if (props.value) {
      return;
    }
    return chevron;
  };
  return <Select {...props} rightSection={rightSection()} />;
}

export default PfSelect;
